import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';
import { Observable }     from 'rxjs/Observable';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';

import {Matrimonio} from '../beans/matrimonio';


@Injectable()
export class MatrimoniService {


	private heroesUrl='api/matrimoni';
	private headers = new Headers({'Content-Type': 'application/json'});


	constructor (private http:Http){}

	getMatrimoni(): Promise<Matrimonio[]> {
		return this.http.get(this.heroesUrl)
				.toPromise()
				.then(response=>response.json().data as Matrimonio[])
				.catch(this.handleError);
	} 

	getMatrimonio(id: number): Promise<Matrimonio>{
		const url = `${this.heroesUrl}/${id}`;
		return this.http.get(url).toPromise().then(response=> response.json().data as Matrimonio)
		.catch(this.handleError);
	}

	search(term: string): Observable<Matrimonio[]> {
    return this.http
               .get(`api/matrimoni/?name=${term}`)
               .map(response => response.json().data as Matrimonio[]);
  }

private handleError(error: any){
	console.error('Error in libri app',error);
	return Promise.reject(error.message||error);
}



}


// WEBPACK FOOTER //
// /Users/paspao/workspaceForMaven/libri/libriweb/src/app/services/matrimoni.service.ts